import { styled } from 'styled-components';

import { breakpointLargeTablet } from 'app/style/breakpoints';
import { spinner } from 'app/style/mixins';

export const StyledContainer = styled.div`
    width: 100%;
    height: 100%;
    min-height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledSpinner = styled.div`
    ${spinner};
    border-width: 5px;
    width: 80px;
    height: 80px;

    @media (min-width: ${breakpointLargeTablet}) {
        width: 120px;
        height: 120px;
    }
`;
